/**
 * @exports default
 */
export default {
  ADOBE_ACCOUNT_BASE: 'schibstedspainmotor',
  ADOBE_ACCOUNT_ENV: 'prod',
  ENVIRONMENT: 'production',
  API_SUBDOMAIN: 'web.',
  API_DOMAIN: 'gw.coches.net',
  API_GW_DOMAIN: 'gw.coches.net',
  API_GW_SUBDOMAIN_CNET_CONTENT: 'cnet-content.',
  API_INTERNAL_URL: 'http://ms-mt--api-gateway-web.mt-pro.motor-internal.com',
  SESSION_STARTER_URL: 'session-starter.',
  CONTENTFUL_API_URL: 'https://content.gw.coches.net',
  ADVERTISING_ENV: 'pro',
  RE_CAPTCHA_KEY: '6LenZh0TAAAAAK4BBwLTdKH0nttWU3Yki0N-T5l0',
  ADYEN_SCRIPT: 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/3.1.0/adyen.js',
  ADYEN_STYLES: 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/3.1.0/adyen.css',
  CALL_ME_NOW_CAMPAIGN_CODE: 'HR21',
  SAITAMA_CONFIG_URL: 'https://adit.gw.coches.net/saitama/v1',
  SECURE_COOKIES: true,
  MESSAGING_WIDGET_ENV: 'pro',
  TRUST_FEEDBACK_API_URL: 'https://feedback-api.trust-pro.mpi-internal.com',
  SEO_CONTENT_API_URL: 'https://seo-content.gw.coches.net'
}
